import(/* webpackChunkName: "faqModule" */ '../../Styles/Faq/faqModule.scss');
import(/* webpackChunkName: "forms" */ 'Feature/Forms/code/Styles/forms.scss');

await import(/* webpackChunkName: "ajax" */ 'Feature/Common/code/Scripts/Common/ajax.js');
await import(/* webpackChunkName: "collapse" */ 'bootstrap/js/dist/collapse');

window.am = window.am || {};

window.am.faqmodule = new function () {
    var that = this;

    that.init = function () {
        var categoryContainers = document.querySelectorAll('.faq-module .faq-module__categories');
        var orderByContainers = document.querySelectorAll('.faq-module .faq-module__orderby');

        categoryContainers.forEach(function (categoryContainer) {
            var checkboxes = categoryContainer.querySelectorAll('input[type="checkbox"]');
            checkboxes.forEach(function (checkbox) {
                checkbox.addEventListener('change', that.onCategoryChange);
            });
        });

        orderByContainers.forEach(function (orderByContainer) {
            var orderBySelect = orderByContainer.querySelector('select[name="faq-module__orderby"]');
            orderBySelect.addEventListener('change', that.onOrderByChange);

            var orderSelect = orderByContainer.querySelector('select[name="faq-module__order"]');
            orderSelect.addEventListener('change', that.onOrderChange);
        });
    };

    that.ApplyFilterOnWindowLocation = function (currentElement) {
        var queryStringParts = [
            that.getCategoryFilterQueryString(currentElement),
            that.getOrderByQueryString(currentElement),
            that.getOrderQueryString(currentElement)
        ];

        window.location = window.location.pathname + '?' + queryStringParts.join('&');
    };

    that.onCategoryChange = function (e) {
        e.preventDefault();
        that.ApplyFilterOnWindowLocation(this);
    };

    that.onOrderByChange = function (e) {
        e.preventDefault();
        that.ApplyFilterOnWindowLocation(this);
    };

    that.onOrderChange = function (e) {
        e.preventDefault();
        that.ApplyFilterOnWindowLocation(this);
    };

    that.getCategoryFilterQueryString = function (currentElement) {
        var categoryIdsChecked = [];
        var checkedCategoryCheckboxes = currentElement
            .closest('.faq-module')
            .querySelector('.faq-module__categories')
            .querySelectorAll('input[type="checkbox"]:checked');

        checkedCategoryCheckboxes.forEach(function (checkbox) {
            categoryIdsChecked.push(checkbox.value);
        });

        return 'filter-categories=' + categoryIdsChecked.join('|');
    };

    that.getOrderByQueryString = function (currentElement) {
        var select = currentElement
            .closest('.faq-module')
            .querySelector('.faq-module__orderby select[name="faq-module__orderby"]');

        if (select == null || typeof select == undefined) {
            return null;
        }

        return 'order-by=' + select.value;
    };

    that.getOrderQueryString = function (currentElement) {
        var select = currentElement
            .closest('.faq-module')
            .querySelector('.faq-module__orderby select[name="faq-module__order"]');

        if (select == null || typeof select == undefined) {
            return null;
        }

        return 'order=' + select.value;
    };
};

window.am.faqmodule.init();